// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__bBP65","left":"StickyBox_left__3xaSe","right":"StickyBox_right__1RylI"};